import { render, staticRenderFns } from "./SideCategoryPanel.vue?vue&type=template&id=1f7b81f4&scoped=true&"
import script from "./SideCategoryPanel.vue?vue&type=script&lang=js&"
export * from "./SideCategoryPanel.vue?vue&type=script&lang=js&"
import style0 from "./SideCategoryPanel.vue?vue&type=style&index=0&id=1f7b81f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7b81f4",
  null
  
)

export default component.exports